/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkAddSyncEntityRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {BulkAddSyncEntityResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const bulkAddSyncEntity = (request:BulkAddSyncEntityRequest, options?: CashRequestOptions) => post<BulkAddSyncEntityRequest, BulkAddSyncEntityResponse>("/2.0/cash/bulk-add-sync-entity", request, {...options, rejectOnError: true })